module.exports = require("./sv.d.ts");